import axios from "axios";
import {KI_LogoGeneration_Result} from "../databaseInterfaceClasses";
export class ProgressGETPoller {
    private readonly url: string;
    private readonly onProgress: (progress: string) => void;
    private readonly pollingInvervalMilliseconds: number = 1500;
    private timeoutIntervalID: number | null = null;
    private canceled = false;

    public constructor(url: string, onProgress: (progress: string) => void, pollingInvervalMilliseconds: number = 1500) {
        this.url = url;
        this.onProgress = onProgress;
        this.pollingInvervalMilliseconds = pollingInvervalMilliseconds;
    }

    public pollUntilFinished() {
        return new Promise<KI_LogoGeneration_Result>(
            (resolve, reject) => {
                if (this.canceled) {
                    return;
                }
                axios.get(this.url).then(response => {
                    const data = response.data as KI_LogoGeneration_Result;
                    if (data.finished) {
                        resolve(response.data);
                        return;
                    }
                    if (data.error) {
                        reject(response.data)
                        return;
                    }
                    this.onProgress(data.progress);
                    this.timeoutIntervalID = setTimeout(() => this.pollUntilFinished().then(resolve).catch(reject), this.pollingInvervalMilliseconds);
                });
            })
    }

    public cancel() {
        if (this.timeoutIntervalID !== null) {
            clearTimeout(this.timeoutIntervalID);
        }
        this.canceled = true;
    }
}
